import type { ChatType } from '../common'
import type { UseQueryResult } from '@tanstack/react-query'

import { keepPreviousData, useQuery } from '@tanstack/react-query'

import http from '../../../lib/http'

export type ChatsMetaQueryKey = [
  'chats/meta',
  {
    userId?: string
    patientId?: string
  }
]

export interface ChatsMetaQueryData {
  chats: Record<ChatType, ChatStats>
  careteamMemberId: string
}

export interface ChatStats {
  unreadCount?: number | null
}

type UseChatsMetaQueryOptions = ChatsMetaQueryKey[1]

export function useChatsMetaQuery (options: UseChatsMetaQueryOptions): UseQueryResult<ChatsMetaQueryData, unknown> {
  return useQuery<ChatsMetaQueryData, unknown, ChatsMetaQueryData, ChatsMetaQueryKey>({
    queryKey: getChatsMetaQueryKey(options),

    async queryFn ({ queryKey }) {
      let [ , { userId, patientId }] = queryKey

      if (typeof userId !== 'string' || !userId) {
        return
      }

      let params = new URLSearchParams([
        ...(typeof patientId === 'string' ? [[ 'patient-id', `Patient/${patientId}` ]] : [])
      ])

      let response = await http.getRequest(`/chats/meta?${params.toString()}`)
      return response
    },

    enabled: typeof options.userId === 'string',
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false
  })
}

export function getChatsMetaQueryKey (options: UseChatsMetaQueryOptions): ChatsMetaQueryKey {
  return [
    'chats/meta',
    { ...options }
  ]
}
